(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lmp-learning-context"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lmp-learning-selection')) {
    class LmpLearningSelection extends HTMLElement {
      connectedCallback() {
        if (this.initialized) {
          document.addEventListener('change',this.externalChange);
          window.addEventListener('pageshow',this.restorePage);
          return;
        }
        this.initialized = true;
        this.strings = JSON.parse(this.querySelector('[data-learning-strings]').textContent);
        this.button = this.querySelector('[data-learning-add]');
        this.status = this.querySelector('[data-learning-status]');
        this.formatter = new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {style:'currency',currency:this.dataset.currency || 'EUR'});
        this.cartVariants = new Set((this.dataset.cartVariants || '').split(',').filter(Boolean));
        this.addEventListener('change', () => this.update());
        this.button.addEventListener('click', () => this.addSelection());
        this.externalChange = event => {
          if (this.contains(event.target) || event.target.name !== 'id') return;
          const select = this.querySelector('[data-current-product] [data-learning-variant]');
          if (select && Array.from(select.options).some(option => option.value === event.target.value)) {
            select.value = event.target.value;
            this.update();
          }
        };
        document.addEventListener('change',this.externalChange);
        this.restorePage = async event => {
          if (!event.persisted) return;
          this.busy = false;
          this.update();
          try {
            const cart = await this.request(this.dataset.cartUrl + '.js');
            this.cartVariants = new Set(cart.items.map(item => String(item.variant_id)));
            this.update();
          } catch (_) {}
        };
        window.addEventListener('pageshow',this.restorePage);
        this.update();
      }
      disconnectedCallback() {
        document.removeEventListener('change',this.externalChange);
        window.removeEventListener('pageshow',this.restorePage);
      }
      rows() { return Array.from(this.querySelectorAll('[data-learning-item]')); }
      selected() {
        const unique = new Map();
        this.rows().forEach(row => {
          const check = row.querySelector('[data-learning-check]');
          const option = row.querySelector('[data-learning-variant]').selectedOptions[0];
          if (check.checked && !check.disabled && option && option.dataset.available === 'true') unique.set(option.value,{id:option.value,quantity:1,price:Number(option.dataset.price)});
        });
        return Array.from(unique.values());
      }
      update() {
        this.rows().forEach(row => {
          const option = row.querySelector('[data-learning-variant]').selectedOptions[0];
          const check = row.querySelector('[data-learning-check]');
          const available = option && option.dataset.available === 'true';
          const inCart = option && this.cartVariants.has(option.value);
          check.disabled = !available || inCart;
          if (inCart) check.checked = true;
          row.querySelector('[data-learning-label]').textContent = inCart ? this.strings.in_cart : available ? this.strings.select : this.strings.unavailable;
          const price = Number(option?.dataset.price || 0);
          row.querySelector('[data-learning-price]').textContent = price === 0 ? this.strings.free : this.formatter.format(price / 100);
        });
        const selected = this.selected();
        this.querySelector('[data-learning-count]').textContent = selected.length ? this.strings.count.replace('[count]',String(selected.length)) : this.strings.choose;
        this.querySelector('[data-learning-total]').textContent = this.formatter.format(selected.reduce((total,item) => total+item.price,0)/100);
        this.button.disabled = this.busy || !selected.length;
        this.button.textContent = this.busy ? this.strings.busy : this.strings.add + (selected.length ? ` (${selected.length})` : '');
      }
      async request(url,options={}) {
        const response = await fetch(url,{credentials:'same-origin',cache:'no-store',...options});
        const data = await response.json();
        if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : this.strings.error);
        return data;
      }
      async addSelection() {
        if (this.busy) return;
        const chosen = this.selected();
        if (!chosen.length) return;
        this.busy = true;
        this.status.textContent = '';
        this.status.removeAttribute('data-error');
        this.update();
        try {
          const cart = await this.request(this.dataset.cartUrl + '.js');
          this.cartVariants = new Set(cart.items.map(item => String(item.variant_id)));
          const items = chosen.filter(item => !this.cartVariants.has(item.id)).map(({id,quantity}) => ({id,quantity}));
          if (items.length) {
            await this.request(this.dataset.addUrl,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
          } else {
            this.status.textContent = this.strings.already;
          }
          window.location.assign(this.dataset.cartUrl);
        } catch (error) {
          this.status.textContent = error.message || this.strings.error;
          this.status.setAttribute('data-error','true');
          try {
            const current = await this.request(this.dataset.cartUrl + '.js');
            this.cartVariants = new Set(current.items.map(item => String(item.variant_id)));
          } catch (_) {}
          this.busy = false;
          this.update();
        }
      }
    }
    customElements.define('lmp-learning-selection',LmpLearningSelection);
  }
  } catch(e) { console.error(e); }
})();

})();
